import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function CookiePolicy() {
  const navigate = useNavigate();
  return (
    <div className="max-w-2xl mx-auto px-5 py-8 space-y-6 text-slate-700">
      <button onClick={() => navigate(-1)} className="flex items-center gap-1.5 text-sm text-slate-500 hover:text-[#0F172A] transition-colors mb-2" data-testid="back-btn">
        <ArrowLeft className="w-4 h-4" /> Indietro
      </button>
      <h1 className="font-heading text-3xl font-bold text-[#0F172A]">Cookie Policy</h1>
      <p className="text-sm text-slate-400">Ultimo aggiornamento: marzo 2026</p>

      <section className="space-y-2">
        <h2 className="font-semibold text-lg text-[#0F172A]">Cosa sono i cookie</h2>
        <p className="text-sm leading-relaxed">
          I cookie sono piccoli file di testo salvati sul tuo dispositivo quando visiti un sito web.
          Vengono usati per far funzionare il sito, migliorare l'esperienza utente e mostrare annunci pertinenti.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="font-semibold text-lg text-[#0F172A]">Cookie tecnici (necessari)</h2>
        <div className="bg-slate-50 rounded-xl p-4 text-sm space-y-1">
          <div className="flex justify-between"><span className="font-medium">Service Worker / Cache</span><span className="text-slate-400">Funzionamento PWA offline</span></div>
          <div className="flex justify-between"><span className="font-medium">LocalStorage</span><span className="text-slate-400">Salvataggio promemoria</span></div>
        </div>
        <p className="text-xs text-slate-400">Questi cookie sono necessari al funzionamento dell'app e non possono essere disabilitati.</p>
      </section>

      <section className="space-y-2">
        <h2 className="font-semibold text-lg text-[#0F172A]">Cookie pubblicitari (Google AdSense)</h2>
        <p className="text-sm leading-relaxed">
          Utilizziamo Google AdSense per mostrare annunci pubblicitari. Google può usare cookie per
          personalizzare gli annunci in base alle tue preferenze e navigazione.
        </p>
        <div className="bg-slate-50 rounded-xl p-4 text-sm space-y-1">
          <div className="flex justify-between"><span className="font-medium">__gads, __gpi</span><span className="text-slate-400">Google AdSense – targeting annunci</span></div>
          <div className="flex justify-between"><span className="font-medium">IDE, DSID</span><span className="text-slate-400">Google DoubleClick – misurazione</span></div>
        </div>
        <p className="text-sm">
          Per gestire le preferenze pubblicitarie di Google:{" "}
          <a href="https://adssettings.google.com" target="_blank" rel="noreferrer" className="text-blue-600 hover:underline">
            adssettings.google.com
          </a>
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="font-semibold text-lg text-[#0F172A]">Come disabilitare i cookie</h2>
        <p className="text-sm leading-relaxed">
          Puoi disabilitare i cookie dalle impostazioni del tuo browser. Tieni presente che disabilitando
          i cookie alcune funzionalità potrebbero non funzionare correttamente.
        </p>
        <ul className="text-sm space-y-1 list-disc pl-5">
          <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noreferrer" className="text-blue-600 hover:underline">Chrome</a></li>
          <li><a href="https://support.apple.com/it-it/guide/safari/sfri11471/mac" target="_blank" rel="noreferrer" className="text-blue-600 hover:underline">Safari</a></li>
          <li><a href="https://support.mozilla.org/it/kb/protezione-antitracciamento-avanzata-firefox" target="_blank" rel="noreferrer" className="text-blue-600 hover:underline">Firefox</a></li>
        </ul>
      </section>
    </div>
  );
}
